<template>
  <b-tooltip
    v-if="showIcon"
    :label="tooltipLabel"
    position="is-bottom">
    <b-icon
      icon="alert"
      :type="iconType"
      :size="size"/>
  </b-tooltip>
</template>

<script>
import { LIMITE_AU_PAIEMENT_COMPTANT, TOTAL } from '@/configuration/tiers/levelBlocage';
import levelString from '@/services/tiers/levelToString';

export default {
  name: 'NiveauBlocageIcone',

  props: {
    niveau: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
  },

  computed: {
    showIcon() {
      return this.niveau === LIMITE_AU_PAIEMENT_COMPTANT.toString()
        || this.niveau === TOTAL.toString();
    },

    iconType() {
      return this.niveau === LIMITE_AU_PAIEMENT_COMPTANT.toString()
        ? 'is-warning'
        : 'is-danger';
    },

    tooltipLabel() {
      if (this.description) {
        return this.description;
      }
      return levelString(this.$i18n, this.niveau);
    },
  },
};
</script>
